const devices = {
    android: function() {
        return navigator.userAgent.match(/Android/i)
    },
    blackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i)
    },
    ios: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i)
    },
    opera: function() {
        return navigator.userAgent.match(/Opera Mini/i)
    },
    windows: function() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i)
    },
    any: function() {
        return (
            devices.android() || devices.blackBerry() || devices.ios() || devices.opera() || devices.windows() || false
        )
    },
}

/**
 * Checks if a flag emoji can render with full colors
 * and not in the fallback - black and white style
 * Creates a virtual canvas and attempts to render
 * a flag emoji with colors in that canvas. If the image data
 * isn't repeating itself it concludes that the
 * flag emoji has rendered with full colors
 * @return boolean
 * */
export const supportsFlagEmoji = () => {
    const canvas = document.createElement('canvas')
    canvas.height = 10
    canvas.width = canvas.height * 2
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    ctx.font = canvas.height + 'px Arial'
    ctx.fillText('🇬🇧', 0, canvas.height)
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data
    let i = 0
    while (i < data.length) {
        if (data[i] !== data[i + 1] || data[i] !== data[i + 2]) return true
        i += 4
    }
    return false
}

/**
 * Detects if the device is mobile
 * @param device Check if the device is a specific device type (optional)
 * @return boolean
 */
export const isMobile = (device?: keyof typeof devices) => {
    //Avoid DevTools assuming mobile device when using responsive mode if resolution is wide
    if (process.env.NODE_ENV === 'development' && window.innerWidth > 767) {
        return false
    }

    if (device) {
        return devices[device]()
    }

    return devices.any()
}

declare const window: any

export const isSmartTV = window.isSmartTV

export const rand = (min = 0, max = 1) => Math.random() * (max - min) + min

export const maxScroll = element => element.scrollWidth - element.clientWidth

export const insertAfter = (node, inserted) => node.parentNode.insertBefore(inserted, node.nextSibling)

export const isHttpSuccess = ({ status }) => 200 <= status && status <= 299
